import styled, { css } from "styled-components";

const activeStyles = css`
  background: ${({ theme }) => theme.colors.accent[50]};
  border-color: ${({ theme }) => theme.colors.accent[200]};
  box-shadow: ${({ theme }) => theme.shadows.card};

  .iconWrapper {
    background: ${({ theme }) => theme.colors.accent[100]};

    svg {
      color: ${({ theme }) => theme.colors.accent[500]};
      fill: ${({ theme }) => theme.colors.accent[500]};
    }
  }

  .toggle {
    background: ${({ theme }) => theme.colors.accent[500]};

    &::after {
      transform: translateX(16px);
    }
  }

  .serviceTypeName {
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .capacitySection {
    max-height: 80px;
    opacity: 1;
    margin-top: ${({ theme }) => theme.spacing[12]};
  }
`;

export const ServiceTypeFormCardStyles = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.radius[12]};
  padding: ${({ theme }) => theme.spacing[16]};
  background: ${({ theme }) => theme.colors.semantic.container.white};
  border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
  box-shadow: none;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  .cardHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .iconWrapper {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.primary[100]};
    transition: background 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    svg {
      width: 20px;
      height: 20px;
      color: ${({ theme }) => theme.colors.primary[400]};
      fill: ${({ theme }) => theme.colors.primary[400]};
      transition: color 0.25s cubic-bezier(0.4, 0, 0.2, 1),
        fill 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  .toggle {
    position: relative;
    width: 36px;
    height: 20px;
    border-radius: ${({ theme }) => theme.radius.rounded};
    background: ${({ theme }) => theme.colors.primary[200]};
    cursor: pointer;
    border: none;
    padding: 0;
    outline: none;
    transition: background 0.25s cubic-bezier(0.4, 0, 0.2, 1);

    &::after {
      content: "";
      position: absolute;
      top: 2px;
      left: 2px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: ${({ theme }) => theme.colors.semantic.container.white};
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
      transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      transform: translateX(0);
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.25);
    }
  }

  .cardBody {
    margin-top: ${({ theme }) => theme.spacing[12]};
  }

  .serviceTypeName {
    margin: 0;
    font-weight: ${({ theme }) => theme.typography.title.t2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b1.lineHeight};
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    transition: color 0.2s ease;
  }

  .capacitySection {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    margin-top: 0;
    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      opacity 0.25s ease,
      margin-top 0.25s ease;
  }

  .capacityLabel {
    display: block;
    font-size: ${({ theme }) => theme.typography.label.size};
    line-height: ${({ theme }) => theme.typography.label.lineHeight};
    font-weight: ${({ theme }) => theme.typography.label.weight};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    margin-bottom: ${({ theme }) => theme.spacing[4]};
  }

  .capacityInput {
    width: 100%;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    border-radius: ${({ theme }) => theme.radius[8]};
    padding: 6px ${({ theme }) => theme.spacing[12]};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.15s ease;

    &:focus {
      border-color: ${({ theme }) => theme.colors.semantic.text.strong};
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.semantic.text.placeholder};
    }
  }

  ${({ $isActive }) => $isActive && activeStyles}
`;
